import React from 'react';

function QCUser({ user }) {
	const { first_name, last_name, email, avatar_path } = user;
	const initials = `${first_name[0]}${last_name[0]}`;
	return (
		<div className='flex items-center gap-2'>
			{avatar_path ? (
				<img
					src={avatar_path}
					alt={`${first_name} ${last_name}`}
					className='w-16 h-16 aspect-square rounded-full bg-grey'
				/>
			) : (
				<div
					className='w-16 h-16 aspect-square rounded-full bg-grey flex items-center justify-center font-semibold text-white text-2xl'
					aria-label={`${first_name} ${last_name}`}
				>
					{initials}
				</div>
			)}
			<div>
				<h3 className='font-semibold'>{first_name} {last_name}</h3>
				<p className='text-sm font-normal'>{email}</p>
			</div>
		</div>
	);
}

export default QCUser;